export default __webpack_public_path__ + "static/media/04.bd8308d9.jpg";